if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
if (this.cart) {
  formData.append(
    'sections',
    this.cart.getSectionsToRender().map((section) => section.id)
  );
  formData.append('sections_url', window.location.pathname);
  this.cart.setActiveElement(document.activeElement);
}
config.body = formData;

// Active l'état "loading" avant d'envoyer la requête
this.submitButton.classList.add('loading');
this.submitButton.setAttribute('aria-disabled', true);
this.querySelector('.loading__spinner').classList.remove('hidden');

fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        errors: response.errors || response.description,
        message: response.message,
      });
      this.handleErrorMessage(response.description);
      return;
    }

    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    if (soldOutMessage) {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButtonText.classList.add('hidden');
      soldOutMessage.classList.remove('hidden');
      this.error = true;
      return;

    } else if (!this.cart) {
  // -------------------------
  // Robust update when no cart component present
  // -------------------------
  console.info('[product-form] No cart element found — updating icon and trying to refresh sections.');

  // 1) Check response items presence (we're in the .then(response)=> block and "response" is in scope)
  try {
    if (response && response.items && Array.isArray(response.items)) {
      console.info('[product-form] cart/add response items:', response.items.length);
    } else {
      console.warn('[product-form] cart/add response has no items field — response:', response);
    }
  } catch (err) {
    console.error('[product-form] error reading response.items', err);
  }

  // 2) Update cart icon bubble if possible
  fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' })
    .then(res => {
      if (!res.ok) throw new Error('cart-icon-bubble request failed: ' + res.status);
      return res.json();
    })
    .then(data => {
      if (data && data['cart-icon-bubble']) {
        const cartIcon = document.querySelector('.cart-icon-bubble');
        if (cartIcon) {
          cartIcon.innerHTML = data['cart-icon-bubble'];
          console.info('[product-form] cart icon updated.');
        } else {
          console.warn('[product-form] .cart-icon-bubble not found in DOM.');
        }
      } else {
        console.warn('[product-form] cart-icon-bubble section not returned by server.');
      }
    })
    .catch(err => {
      console.warn('[product-form] error fetching cart-icon-bubble:', err);
    });

  // 3) Try to refresh drawer/notification sections if theme supports them
  fetch('/?sections=cart-drawer,cart-notification', { credentials: 'same-origin' })
    .then(res => {
      if (!res.ok) throw new Error('sections request failed: ' + res.status);
      return res.json();
    })
    .then(data => {
      // cart-drawer
      if (data['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.innerHTML = data['cart-drawer'];
          console.info('[product-form] cart-drawer updated.');
        } else {
          console.info('[product-form] cart-drawer section received but no <cart-drawer> element in DOM.');
        }
      }
      // cart-notification
      if (data['cart-notification']) {
        const notif = document.querySelector('cart-notification');
        if (notif) {
          notif.innerHTML = data['cart-notification'];
          console.info('[product-form] cart-notification updated.');
        } else {
          console.info('[product-form] cart-notification returned but no <cart-notification> element in DOM.');
        }
      }
    })
    .catch(err => {
      console.warn('[product-form] error fetching drawer/notification sections:', err);
    });

  // 4) As a final sanity check, fetch /cart.js to verify server-side contents (non-visual)
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(r => {
      if (!r.ok) throw new Error('cart.js request failed: ' + r.status);
      return r.json();
    })
    .then(cartData => {
      console.info('[product-form] server cart.js items count:', cartData.items.length, cartData.items);
      // If the server cart is empty (0 items) despite the add request, log an error
      if (!cartData.items || cartData.items.length === 0) {
        console.error('[product-form] WARNING — cart.js shows 0 items after add. The add request may have failed server-side.');
      }
    })
    .catch(err => {
      console.warn('[product-form] could not load /cart.js for sanity check:', err);
    });

  // 5) don't redirect — return to leave normal flow
  return;
}

    const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
    if (!this.error)
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: response,
      }).then(() => {
        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      });

    this.error = false;

    const quickAddModal = this.closest('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener(
        'modalClosed',
        () => {
          setTimeout(() => {
            // CartPerformance.measure("add:paint-updated-sections", () => {
            //   this.cart.renderContents(response);
            // });
          });
        },
        { once: true }
      );
      quickAddModal.hide(true);
    } else {
      CartPerformance.measure("add:paint-updated-sections", () => {
        // this.cart.renderContents(response);
      });
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty'))
      this.cart.classList.remove('is-empty');
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');

    CartPerformance.measureFromEvent("add:user-action", evt);
  });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
